import React from 'react';
import { Main } from './components';

const ViewPreInvoices = () => <Main />;

export default ViewPreInvoices;
